import { LogoHeader } from "@/components/ui/layout/menuSidebar/logo-header"
import { NavCreateBox } from "@/components/ui/layout/menuSidebar/nav-create-box"
import { NavFooter } from "@/components/ui/layout/menuSidebar/nav-footer"
import { NavMain } from "@/components/ui/layout/menuSidebar/nav-main"
import { NavStripe } from "@/components/ui/layout/menuSidebar/nav-stripe"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarTrigger,
  useSidebarMenu,
} from "@/components/ui/layout/menuSidebar/sidebar"
import { useBoxs } from "@/modules/box/hooks/useBox"
import { motion } from "motion/react"

export function AppSidebarMenu({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { open } = useSidebarMenu()
  const { data: boxs } = useBoxs()
  const hasBoxs = boxs.length > 0

  return (
    <Sidebar collapsible="icon" {...props} id="app-sidebar">
      <SidebarHeader className="ml-1 flex h-20 min-h-9 items-center justify-start overflow-hidden rounded-lg px-2 transition-discrete duration-400 ease-out">
        <LogoHeader />
      </SidebarHeader>
      <SidebarTrigger />
      <SidebarContent>
        <NavMain className="flex-1" />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: open && !hasBoxs ? 1 : 0 }}
          transition={{
            delay: 0.25,
            duration: 0.25,
            ease: "easeInOut",
          }}
          className={open && !hasBoxs ? "block" : "hidden"}
        >
          <NavCreateBox />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: open && hasBoxs ? 1 : 0 }}
          transition={{
            delay: 0.25,
            duration: 0.25,
            ease: "easeInOut",
          }}
          className={open && hasBoxs ? "block" : "hidden"}
        >
          <NavStripe />
        </motion.div>
      </SidebarContent>
      <SidebarFooter>
        <NavFooter />
      </SidebarFooter>
    </Sidebar>
  )
}
